import tokens from '../../Tokens/tokens';

export const colors = tokens.colors.legacy;

export default colors;

